export const GTM_LOADING_TIMEOUT_NAME = 'mcmGtmLoadingTimeout';
export const GA_TRACKING_PARAMS_NAME = 'mcmGaTrackingParams';
